import React from 'react';
import Collection3 from './Collection3';

const HomeCollection = () => {
  return (
    <div>
      <div className="section mt-100">
        <div className="container">
          <Collection3 length={6} viewAll={true} market={true} />
        </div>
      </div>
    </div>
  );
};

export default HomeCollection;
